var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PLUX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Launcher/Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bg",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rounnd",
    fill: "#212121",
    x: 40,
    y: 40,
    width: 432,
    height: 432,
    rx: 216
  }), /*#__PURE__*/React.createElement("g", {
    id: "Brand/LightMode/Symbol:Mobile",
    transform: "translate(116.000000, 115.996545)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.029366,47.8459147 L137.972016,135.788565 L225.914666,47.8459147 L232.15754,54.0887891 L144.21489,142.031439 L232.15754,229.974089 L225.914666,236.216963 L137.972016,148.274313 L50.029366,236.216963 L43.7864916,229.974089 L131.729141,142.031439 L43.7864916,54.0887891 L50.029366,47.8459147 Z M89.607877,140.003455 L0,229.607877 L50.3955778,280.003455 L140.003455,190.399033 L229.607877,280.003455 L280.003455,229.607877 L190.395578,140.003455 L275.944032,54.4550009 L225.548454,4.05942304 L140,89.607877 L50.3955778,0 L0,50.3955778 L89.607877,140.003455 Z",
    id: "Fill-8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.eb7af09bd90ed8cce78ec891d74191eb.svg";
export { ForwardRef as ReactComponent };